/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Frame_ErrorInputs */

const en_cookie_frame_error = /** @type {(inputs: Cookie_Frame_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This content could not be loaded.`)
};

const lv_cookie_frame_error = /** @type {(inputs: Cookie_Frame_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neizdevās ielādēt šo saturu.`)
};

/**
* | output |
* | --- |
* | "This content could not be loaded." |
*
* @param {Cookie_Frame_ErrorInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_frame_error = /** @type {((inputs?: Cookie_Frame_ErrorInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Frame_ErrorInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_frame_error(inputs)
	return en_cookie_frame_error(inputs)
});